export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8921.a107f7b2.jpg";